/**
 * Customer reviews: mobile horizontal scroll (264px cards), drag/touch, auto-advance on release.
 */
(function () {
  "use strict";

  var MOBILE_MQ = "(max-width: 1023px)";

  function initViewport(viewport) {
    if (!viewport || viewport.dataset.customerReviewsInit === "true") return;
    viewport.dataset.customerReviewsInit = "true";

    var grid = viewport.querySelector(".customer-reviews__grid");
    if (!grid) return;

    var items = grid.querySelectorAll(".customer-reviews__item");
    if (!items.length) return;

    var paused = false;
    var timerId = null;
    var delayMs = parseInt(viewport.dataset.autoplayDelay, 10);
    if (isNaN(delayMs) || delayMs < 1000) delayMs = 5000;

    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function getScrollStep() {
      var gap = parseFloat(getComputedStyle(grid).gap) || 16;
      return items[0].offsetWidth + gap;
    }

    function scrollNext() {
      if (!isMobile() || paused || items.length < 2) return;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (maxScroll <= 0) return;
      var step = getScrollStep();
      if (viewport.scrollLeft >= maxScroll - 2) {
        viewport.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        viewport.scrollBy({ left: step, behavior: "smooth" });
      }
    }

    function stopAutoplay() {
      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isMobile() || items.length < 2 || prefersReducedMotion()) return;
      timerId = window.setInterval(scrollNext, delayMs);
    }

    function pauseInteraction() {
      paused = true;
      stopAutoplay();
    }

    function resumeInteraction() {
      paused = false;
      startAutoplay();
    }

    viewport.addEventListener("pointerdown", pauseInteraction);
    viewport.addEventListener("pointerup", resumeInteraction);
    viewport.addEventListener("pointercancel", resumeInteraction);

    viewport.addEventListener(
      "touchstart",
      function () {
        pauseInteraction();
      },
      { passive: true },
    );
    viewport.addEventListener(
      "touchend",
      function () {
        resumeInteraction();
      },
      { passive: true },
    );

    window.addEventListener("resize", function () {
      if (isMobile()) {
        startAutoplay();
      } else {
        paused = false;
        stopAutoplay();
        viewport.scrollLeft = 0;
      }
    });

    if (isMobile()) startAutoplay();
  }

  function initAll(root) {
    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll("[js-customer-reviews-viewport]").forEach(initViewport);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
